import React from "react";

/**
 * ClimateTrend — climate_trend evidence component.
 *
 * Mirrors the ComparisonPair / FrostDates layout — large figures separated by
 * vertical dividers — for three stats:
 *
 *   {earliest_year} avg · {latest_year} avg · Change (signed delta)
 *
 * The signed delta is colour-coded: orange for warming, blue for cooling,
 * gray for no change. A muted caption notes the years of record.
 *
 * Spec references: §7 (climate_trend), §2d (formatting).
 */

const ClimateTrend = ({ panel }) => {
  const f = panel.facts || {};
  const early = Number(f.early_avg_high_f) || 0;
  const recent = Number(f.recent_avg_high_f) || 0;
  const delta = recent - early;
  const years = Number(f.years_compared) || 0;
  const earliest = Number(f.earliest_year) || 0;
  const latest = Number(f.latest_year) || 0;

  const deltaColor =
    delta > 0
      ? "text-orange-500 dark:text-orange-400"
      : delta < 0
        ? "text-blue-500 dark:text-blue-400"
        : "text-gray-500 dark:text-gray-400";

  return (
    <div>
      {/* Three stats side by side with dividers — mirrors ComparisonPair */}
      <div className="flex items-baseline justify-center gap-4 sm:gap-6">
        {/* Earliest year avg */}
        <div className="text-center flex-1">
          <span className="text-3xl font-bold text-gray-900 dark:text-gray-100 leading-none">
            {early}°
          </span>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1.5">
            {earliest} avg
          </p>
        </div>

        <div className="w-px h-12 bg-gray-200 dark:bg-gray-700 self-center" />

        {/* Latest year avg */}
        <div className="text-center flex-1">
          <span className="text-3xl font-bold text-gray-900 dark:text-gray-100 leading-none">
            {recent}°
          </span>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1.5">
            {latest} avg
          </p>
        </div>

        <div className="w-px h-12 bg-gray-200 dark:bg-gray-700 self-center" />

        {/* Signed delta */}
        <div className="text-center flex-1">
          <span className={`text-3xl font-bold leading-none ${deltaColor}`}>
            {delta > 0 ? "+" : ""}{delta.toFixed(1)}°
          </span>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1.5">
            Change
          </p>
        </div>
      </div>
    </div>
  );
};

export default ClimateTrend;
